function firstValue(...values) {
  const match = values.find((value) => value !== undefined && value !== null && value !== "");
  return match == null ? "" : match;
}

function buildDefaultPreviewBody() {
  return [
    {
      ItemNoItem: 1,
      ID_Item: "PRD-001",
      PrincipalBarCode: "750100000001",
      ItemDescription: "Servicio de soporte tecnico mensual",
      ItemMeasureUnit: "Mes",
      ItemQuantity: 1,
      ItemUnitPrice: 95,
      ItemDiscount: 5,
      ItemExenta: 0,
      ItemNoSuj: 0,
      ItemNoGravada: 0,
      ItemGravada: 90,
    },
    {
      ItemNoItem: 2,
      ID_Item: "PRD-002",
      PrincipalBarCode: "750100000002",
      ItemDescription: "Licencia de plataforma administrativa",
      ItemMeasureUnit: "Unidad",
      ItemQuantity: 2,
      ItemUnitPrice: 49.5,
      ItemDiscount: 2.5,
      ItemExenta: 9.75,
      ItemNoSuj: 3.5,
      ItemNoGravada: 5.4,
      ItemGravada: 98.75,
    },
  ];
}

function buildLineGuidePreviewBody() {
  return Array.from({ length: 100 }, (_, index) => {
    const itemNumber = index + 1;
    const isLongDescription = itemNumber % 5 === 0;
    const isMediumDescription = itemNumber % 3 === 0;
    const price = isLongDescription ? 18.75 : isMediumDescription ? 12.5 : 8.25;

    return {
      ItemNoItem: itemNumber,
      ID_Item: `CAL-${String(itemNumber).padStart(3, "0")}`,
      PrincipalBarCode: `7501009${String(itemNumber).padStart(5, "0")}`,
      ItemDescription: isLongDescription
        ? `Linea de calibracion ${itemNumber}: descripcion extensa para validar saltos de linea, alto de fila y paginacion real del comprobante en produccion`
        : isMediumDescription
          ? `Linea de calibracion ${itemNumber}: descripcion media con texto adicional`
          : `Linea de calibracion ${itemNumber}`,
      ItemMeasureUnit: itemNumber % 2 === 0 ? "Unidad" : "Servicio",
      ItemQuantity: 1,
      ItemUnitPrice: price,
      ItemDiscount: 0,
      ItemExenta: 0,
      ItemNoSuj: 0,
      ItemNoGravada: 0,
      ItemGravada: price,
    };
  });
}

export function buildBranchDteTemplatePreviewData({
  branch = {},
  business = {},
  previewAssets = {},
  showLineGuide = false,
  hideRelatedDocuments = false,
} = {}) {
  const branchLegalName = firstValue(branch.BranchLegalName, branch.BranchName, "Sucursal Centro");
  const businessName = firstValue(
    business.BusinessName,
    business.name,
    business.BusinessBillingName,
    branchLegalName,
    "Innova Business"
  );
  const legalAddress = firstValue(
    branch.BranchLegalAddress,
    branch.BranchAddress,
    "Avenida Innovacion 123, San Salvador"
  );
  const branchPhone = firstValue(branch.BranchPhone, "+503 2222 3344");
  const branchMobile = firstValue(branch.BranchMobile, "+503 7000 1122");
  const branchEmail = firstValue(branch.BranchEmail, "facturacion@negocio.com");
  const businessActivity = firstValue(
    branch.DescActividad,
    business.BusinessActivity,
    "Servicios empresariales y tecnologia"
  );
  const previewBody = showLineGuide ? buildLineGuidePreviewBody() : buildDefaultPreviewBody();
  const taxableTotal = previewBody.reduce(
    (total, item) => total + Number(item.ItemGravada || 0),
    0
  );
  const exemptTotal = previewBody.reduce(
    (total, item) => total + Number(item.ItemExenta || 0),
    0
  );
  const nonSubjectTotal = previewBody.reduce(
    (total, item) => total + Number(item.ItemNoSuj || 0),
    0
  );
  const nonTaxableTotal = previewBody.reduce(
    (total, item) => total + Number(item.ItemNoGravada || 0),
    0
  );
  const discountTotal = previewBody.reduce(
    (total, item) => total + Number(item.ItemDiscount || 0),
    0
  );
  const ivaTotal = Number((taxableTotal * 0.13).toFixed(2));
  const payableTotal = Number((
    taxableTotal +
    exemptTotal +
    nonSubjectTotal +
    nonTaxableTotal +
    ivaTotal -
    discountTotal
  ).toFixed(2));

  return {
    header: {
      ID_Invoice: "DTE-000145",
      NumeroControl: "DTE-01-S001P001-000000000000145",
      CodigoGeneracion: "B3F34C3C-9F56-40AB-A2ED-91B3CF003211",
      SelloRecepcion: "20260420-113501-000145",
      InvoiceType: "CCF",
      InvoiceDate: "20/04/2026",
      InvoiceCreditDay: 30,
      InvoiceCurrency: "$",
      InvoiceSubTotalVentas: taxableTotal,
      InvoiceTotalGravada: taxableTotal,
      InvoiceTotalDescu: discountTotal,
      InvoiceTotalExenta: exemptTotal,
      InvoiceTotalNoSuj: nonSubjectTotal,
      InvoiceTotalNoGravado: nonTaxableTotal,
      InvoiceTotalIva: ivaTotal,
      InvoiceIvaRete1: 2.45,
      InvoiceIvaPerce1: 1.25,
      InvoiceReteRenta: 0,
      Fovial: 0,
      Cotrans: 0,
      InvoiceTotalPagar: payableTotal,
      InvoiceStatusDescription: "Emitido",
      InvoiceTotalLetras: "Doscientos veintiun dolares con cuarenta y cuatro centavos",
      FullName: "Ana Lopez",
      EmisorUserDui: "01234567-8",
      EmisorUserMobile: branchPhone,
      InvoiceName: "Cliente de Ejemplo, S.A. de C.V.",
      InvoiceAddress: "Colonia Escalon, San Salvador",
      InvoiceAddress2: "Local 4, Centro Comercial Plaza",
      InvoiceNIT: "0614-130990-101-5",
      InvoiceNRC: "178945-2",
      InvoiceEntity: "Comercial",
      ZoneClient: "Metro",
      customerEmail: "compras@cliente-demo.com",
      ClienteTelefonoFijoDeContacto: "+503 2234 8899",
      FullNameSeller: "Carlos Mejia",
      ID_Seller: "V-01",
      ID_Customer: "C-1024",
      ReceptorNumDocumento: "0614-130990-101-5",
      ReceptorNombre: "Cliente de Ejemplo, S.A. de C.V.",
      customerInfo: {
        ID_DocumentType: 4,
        dui: "0614-130990-101-5",
        descActividad: "Comercio al por mayor",
        BusinessContactName: "Mariela Romero",
        BusinessContactPhone: "+503 7854 3366",
      },
      EmisorDescActividad: businessActivity,
      JsonMh: {
        dteJson: {
          IdentificacionTipoModelo: 1,
          IdentificacionTipoOperacion: 1,
        },
      },
    },
    user: {
      business: businessName,
    },
    body: previewBody,
    branch: {
      ID_Branch: branch.ID_Branch,
      AuthFeMode: Number(firstValue(branch.AuthFeMode, 0)),
      BranchPhone: branchPhone,
      BranchMobile: branchMobile,
      BranchEmail: branchEmail,
      BranchLegalAddress: legalAddress,
      BranchLogoPath: firstValue(previewAssets.logoUrl, branch.BranchLogoPath, ""),
      BranchBannerPath: firstValue(previewAssets.bannerUrl, branch.BranchBannerPath, ""),
      BranchBilledInfo: firstValue(branch.BranchBilledInfo, ""),
      BusinessBillingName: branchLegalName,
      BusinessBillingNIT: firstValue(
        branch.BranchLegalNIT,
        business.BusinessBillingNIT,
        "0614-290399-101-7"
      ),
      BusinessBillingNRC: firstValue(
        branch.BranchLegalNRC,
        business.BusinessBillingNRC,
        "245100-3"
      ),
    },
    dteJson: {
      IdentificacionTipoModelo: 1,
      IdentificacionTipoOperacion: 1,
    },
    docRelated: hideRelatedDocuments
      ? []
      : [
        {
          TipoDocumentoRelacionado: "03",
          NumeroDocumentoRelacionado: "CCF-0091",
          FechaEmisionRelacionado: "15/04/2026",
        },
      ],
    invoicePayments: [],
  };
}
